import {PermitExtensionTreesTable} from ".";
import {PermitExtensionTreesForm} from "./form";
import {SectionCard} from "base/ui/section/components";
import {NoDataContainer} from "base/shared/components";

import Stack from "@mui/system/Stack";

const ViewPermitExtensionTreesTable = ({
    extension,
    onSubmit,
    displayFees,
    disabled,
}) => {
    const trees = extension?.tree_set;

    return (
        <PermitExtensionTreesForm extension={extension} onSubmit={onSubmit}>
            <SectionCard>
                <Stack spacing={3} mt={2}>
                    {trees?.length ? (
                        <PermitExtensionTreesTable
                            extension={extension}
                            displayFees={displayFees}
                            disabled={disabled}
                        />
                    ) : (
                        <NoDataContainer text="Esta prorrogação não tem árvores." />
                    )}
                </Stack>
            </SectionCard>
        </PermitExtensionTreesForm>
    );
};

export default ViewPermitExtensionTreesTable;
